import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'

import * as audioActions from '../../Core/Game/AudioContainer/audio.actions'
import * as tutorialSelectors from '../tutorial.selectors'
import * as tutorialActions from '../tutorial.actions'

import CheckBattle from '../../Mars/Battles/CheckBattle/CheckBattle'

const mapDispatchToProps = (dispatch) => {
  return {
    getBattle: () => true,
    removeInfo: () => true,
    removeQuestion: () => true,
    removeResume: () => true,

    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
    addScreen: bindActionCreators(tutorialActions.addScreen, dispatch),
    removeScreen: bindActionCreators(tutorialActions.removeScreen, dispatch),
    setIndividualBattle: bindActionCreators(tutorialActions.setIndividualBattle, dispatch),
  }
}
const mapStateToProps = (state) => ({
  results: tutorialSelectors.getCurrentBattleResults(state),
  info: tutorialSelectors.getBattleInfoFromState(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CheckBattle))
